import React from 'react';
import {
  BrowserRouter, Route, Switch, withRouter,
} from 'react-router-dom';
import LoginPage from './pages/Login';
import BenchmarkingPage from './pages/Benchmarking';
import SharedErrorPage from './pages/SharedError';
import PrivateRoute from './utils/privateRoute';

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={withRouter(LoginPage)} />
      <PrivateRoute exact path="/benchmarking" component={BenchmarkingPage} />
      <Route exact path="/shared/error" component={withRouter(SharedErrorPage)} />
      <Route component={SharedErrorPage} />
    </Switch>
  </BrowserRouter>
);

export default Routes;
